import { gql } from '@apollo/client';

export const CREATE_POSTBACK = gql`
  mutation createPostback($input: PostbackInput) {
    createPostback(input: $input) {
      postback {
        id
        companyId
        targetId
        target {
          companyName
        }
        targetType
        eventType
        url
        queryString
        disabled
        createdAt
      }
    }
  }
`;
